import * as z from "zod/v4";

export const updateCustomJsSettings = {
  name: "updateCustomJsSettings" as const,
  input: z.object({ enabled: z.boolean(), script: z.string().max(51_200) }),
  output: z.null(),
};
